import React from 'react';
import Helmet from 'react-helmet';

const MetaInfo = (props) => {

    return (
        <>
            {props.lang !== 'fr' ?
                <Helmet>
                    <title>A&W Beyond Meat</title>
                    <meta name="description" content="Our Beyond Meat† Burger and Beyond Meat Sausage & Egger are packed with 100% plant-based proteins." />
                </Helmet>
            :
                <Helmet>
                    <title>Les produits Beyond Meat† d’A&W / Beyond Meat† et A&W</title>
                    <meta name="description" content="Notre Burger Beyond Meat et notre Chef-d’œuf avec saucisse Beyond Meat sont faits de protéines végétales à 100 %." />
                </Helmet>
            }
        </>
    )
}
export default MetaInfo;